import { render, staticRenderFns } from "./VaccinationSelectInput.vue?vue&type=template&id=1a67d29f&scoped=true"
import script from "./VaccinationSelectInput.vue?vue&type=script&lang=ts"
export * from "./VaccinationSelectInput.vue?vue&type=script&lang=ts"
import style0 from "./VaccinationSelectInput.vue?vue&type=style&index=0&id=1a67d29f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a67d29f",
  null
  
)

export default component.exports